import PropTypes from 'prop-types';
import ReactLoadingSkeleton from 'react-loading-skeleton';
import { cn } from '../../lib/utils';

export const SkeletonThemeProvider = ({ children }) => children;

export const Skeleton = ({ className, ...props }) => (
  <span className={cn('block leading-none', className)}>
    <ReactLoadingSkeleton
      baseColor="hsl(214 32% 91%)"
      highlightColor="hsl(210 40% 98%)"
      borderRadius="0.5rem"
      {...props}
    />
  </span>
);

Skeleton.propTypes = {
  className: PropTypes.string,
};

export { ReactLoadingSkeleton };
